export enum DeviceGeneralType {
  REMOVABLE = 'removable',
  PLUG_AND_PLAY = 'removable',
  PLUG_AND_PLAY_IBUTTON = 'removable_with_identifier',
  INSTALLED = 'installed',
  BLOCKER = 'installed_with_blocker',
  IMMOBILIZER = 'installed_with_ignition_lock',
  IBUTTON = 'installed_with_identifier',
  IBUTTON_IMMOBILIZER = 'installed_with_ignition_lock_identifier',
  OBD = 'obd',
  DASHCAM = 'camera',
  MULTICAM = 'multicam',
  CAN = 'can_network',
  CAN_IBUTTON = 'can_network_with_identifier',
  CAN_IBUTTON_IMMOBILIZER = 'can_network_with_ignition_lock',
  UNKNOWN = 'others',
}
